import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseCustomLinkComponent } from '../base-custom-link/base-custom-link.component';

@Component({
    selector: 'tran-custom-text-link',
    imports: [TranslatePipe],
    templateUrl: './custom-text-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomTextLinkComponent extends BaseCustomLinkComponent {
    public readonly hasIndicator = input<boolean>(false);
    public readonly isDownload = input<boolean>(false);
}
